
































import { Vue, Component, Prop } from 'vue-property-decorator'
import { FileInfo } from '@/api/types'
import Attendance from '@/assets/attendance.png'
import FileManager from '@/assets/file-manager.png'
import Web from '@/assets/web.png'
import Subcategory from '@/assets/subcategory.png'
import FolderIcon from '@/assets/folder-icon.png'
import FileImage from '@/assets/file-image.png'
import FileText from '@/assets/file-text.png'
type Dictionary<T> = { [key: string]: T }

interface RouterLink {
  name?: string;
  params?: { [key: string]: string };
  path?: string;
  query?: Dictionary<string | (string | null)[]>;
}

interface FileInfoWithRouterLink extends FileInfo {
  Link?: RouterLink;
}

@Component({
  name: 'ExplorerJMFolder'
})
export default class App extends Vue {
  @Prop() files!: FileInfoWithRouterLink[]
  @Prop() xattr!: string[]
  private fff: FileInfoWithRouterLink[] = []
  private FolderIcon: string = FolderIcon
  private FileImage: string = FileImage
  private FileText: string = FileText

  constructor () {
    super()
    this.files.map((v: FileInfoWithRouterLink) => {
      if (!v.XAttr) {
        return v
      }
      switch (v.XAttr.Icon) {
        case 'filemanager':
          v.XAttr.Icon = FileManager
          break
        case 'web':
          v.XAttr.Icon = Web
          break
        case 'subcategory':
          v.XAttr.Icon = Subcategory
          break
        case 'attendance':
          v.XAttr.Icon = Attendance
          break
      }
      return v
    })
  }

  private getLink (idx: number): string {
    return this.$route.path.split('/').reduce<string[]>((acc: string[], curr: string, idx: number) => {
      if (curr) {
        acc.push(acc.slice(idx - 1).join('/') + curr + '/')
      }
      return acc
    }, ['/'])[idx]
  }
}

